"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stackBarModule = _interopRequireDefault(require("./sass/stackBar.module.scss"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StackBar = function StackBar(_ref) {
  var type = _ref.type,
      data = _ref.data,
      maxAmount = _ref.maxAmount,
      indicator = _ref.indicator,
      styleTooltip = _ref.styleTooltip,
      className = _ref.className;
  var progress = data.sort(function (a, b) {
    return b.count - a.count;
  }).map(function (item) {
    var percentage = item.count * 100 / maxAmount;
    return _objectSpread(_objectSpread({}, item), {}, {
      count: percentage
    });
  });
  var stack = data.map(function (item) {
    var percentage = item.count * 100 / maxAmount;
    return _objectSpread(_objectSpread({}, item), {}, {
      count: percentage
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_stackBarModule.default.wrapper, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _stackBarModule.default.barContainer
  }, type === 'progress' && progress.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "progress: ".concat(index),
      className: _stackBarModule.default.barBack,
      style: {
        width: "".concat(item.count, "%"),
        background: item.color
      }
    });
  }), type === 'stack' && /*#__PURE__*/_react.default.createElement("div", {
    className: _stackBarModule.default.barContainerStack
  }, maxAmount <= 0 ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      background: '#E8EAEE',
      width: '100%'
    }
  }) : stack.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "stack: ".concat(index),
      className: _stackBarModule.default.barBackStack,
      "data-testid": "barBackStackID",
      style: {
        background: item.color,
        width: "".concat(item.count, "%")
      }
    });
  })), indicator && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "indicatorID",
    className: _stackBarModule.default.indicator,
    id: "indicator",
    style: {
      left: "calc(".concat(indicator, "% - 7px)")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _stackBarModule.default.indicator_control,
    id: "control",
    style: {
      left: "calc(".concat(indicator, "% - 12px)")
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _stackBarModule.default.wrapperTooltip,
    style: styleTooltip
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _stackBarModule.default.tooltip
  }, /*#__PURE__*/_react.default.createElement("span", null, "Applications received:"), /*#__PURE__*/_react.default.createElement("ul", {
    className: _stackBarModule.default.tooltip_list
  }, data.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: _stackBarModule.default.tooltip_list_item
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _stackBarModule.default.tooltip_list_name
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _stackBarModule.default.tooltip_list_name_circle,
      style: {
        background: item.color
      }
    }), item.status), /*#__PURE__*/_react.default.createElement("div", {
      className: _stackBarModule.default.tooltip_list_number
    }, item.count));
  }))))));
};

StackBar.defaultProps = {
  data: null,
  maxAmount: 25,
  indicator: null,
  styleTooltip: null,
  className: null
};
StackBar.propTypes = {
  data: _propTypes.default.array,
  type: _propTypes.default.oneOf(['stack', 'progress']),
  maxAmount: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.func]),
  indicator: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool]),
  styleTooltip: _propTypes.default.object,
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
};
var _default = StackBar;
exports.default = _default;